import { useQuery } from 'react-query';

import { useAuth } from 'modules/authentication/presentation/contexts';
import { makeFetchCustomerContractByIdUseCase } from 'modules/customer/domain/useCases';
import { customerQueries } from 'modules/customer/presentation/constants';
import { useRequestErrorHandler } from 'shared/presentation/hooks';

type TParams = {
  contractId: number;
  useDefaultErrorHandler?: boolean;
};

export default function useContract({
  contractId,
  useDefaultErrorHandler = true,
}: TParams) {
  const { handleError } = useRequestErrorHandler('customer');
  const auth = useAuth();

  const query = useQuery(
    customerQueries.contract(auth.session?.id, contractId),
    () => {
      if (!auth.session) throw new Error();

      return makeFetchCustomerContractByIdUseCase().execute({
        customerId: auth.session.id,
        contractId,
      });
    },
    {
      onError: error => {
        if (useDefaultErrorHandler) {
          handleError(error);
        }
      },
      enabled: !!auth.session && !isNaN(contractId),
    },
  );

  return {
    loading: query.isLoading,
    contract: query.data || null,
    error: query.error,
  };
}
